var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-inline-block"},[_c('StreamBarcodeReader',{on:{"decode":_vm.onDecode,"loaded":_vm.onLoaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }